import { render, staticRenderFns } from "./PartnerBanner.vue?vue&type=template&id=f8bb22ca&scoped=true&"
import script from "./PartnerBanner.vue?vue&type=script&async=true&lang=js&"
export * from "./PartnerBanner.vue?vue&type=script&async=true&lang=js&"
import style0 from "./PartnerBanner.vue?vue&type=style&index=0&id=f8bb22ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8bb22ca",
  null
  
)

export default component.exports